/**
 * ORW WhatsApp Chat
 *
 * Phones and tablets: the floating button waits until the customer scrolls a
 * little, so it never sits on the first screen's main CTA (homepage
 * "Discover Now"). Desktop shows it straight away. Without JS it always shows.
 */
(function () {
  'use strict';

  var button = document.querySelector('[data-orw-whatsapp-chat]');
  if (!button) return;

  var REVEAL_AFTER = 160;
  var touchLayout = window.matchMedia('(max-width: 989px)');
  var ticking = false;

  function update() {
    ticking = false;
    button.toggleAttribute('data-waiting', touchLayout.matches && window.scrollY < REVEAL_AFTER);
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }, { passive: true });
  touchLayout.addEventListener('change', update);
  update();
})();
